var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 189,
    viewBox: "0 0 185 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 185,
    height: 189
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.294 55.8609L119.807 32.065L155.856 17.9886L150.186 56.3885L127.805 65.2852L116.294 55.8609Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.985 76.4276L146.793 85.9079L184.321 70.7331L171.758 65.4548L150.186 56.3885L127.805 65.2852L125.985 76.4276Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.208 59.9436L150.63 53.3818L150.186 56.3885L171.758 65.4548L180.208 59.9436Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.736 66.6846L180.208 59.9436L171.758 65.4548L174.736 66.6846Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.294 55.8609L119.807 32.065L100.014 2.63325L93.9759 43.5245L107.035 60.9017L116.294 55.8609Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.856 17.9886L119.807 32.065L118.795 30.5988L121.292 29.7386L155.856 17.9886Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.789 0.737L104.55 9.35987L118.795 30.5988L121.292 29.7386L106.789 0.737Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.245 5.94727L106.789 0.737L104.55 9.35987L102.245 5.94727Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0836 48.2043L93.9759 43.5245L100.014 2.63325L74.8673 35.6119L81.0836 48.2043Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8702 49.2064L93.9759 43.5245L107.035 60.9017L112.44 73.6377L110.39 78.6018L87.8702 49.2064Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.985 76.4276L127.805 65.2852L116.294 55.8609L107.035 60.9017L112.44 73.6377L125.985 76.4276Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39 78.6018L145.776 95.7646L146.793 85.9079L125.985 76.4276L112.44 73.6377L110.39 78.6018Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8702 49.2064L93.9759 43.5245L81.0836 48.2043L70.2658 53.1027L87.8702 49.2064Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8673 35.6119L37.1085 26.7889L70.2658 53.1027L81.0836 48.2043L74.8673 35.6119Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4154 28.3554L59.6043 19.4892L55.5217 31.0877L74.8673 35.6119L80.4154 28.3554Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9311 75.8158L70.2658 53.1027L37.1085 26.7889L37.241 63.9389L56.9037 79.3945L68.9311 75.8158Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2169 88.5784L87.8702 49.2064L70.2658 53.1027L68.9311 75.8158L75.1347 88.4942L85.2169 88.5784Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39 78.6018L100.298 91.0685L85.2169 88.5784L87.8702 49.2064L110.39 78.6018Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.776 95.7646L110.39 78.6018L100.298 91.0685L106.445 105.319L145.776 95.7646Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.241 63.9389L0.231689 78.5757L31.4063 103.456L54.3784 94.1196L56.9037 79.3945L37.241 63.9389Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2722 62.539L0.231689 78.5757L37.241 63.9389L37.2722 62.539Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1742 44.1788L17.8615 35.2705L30.1471 65.6126L37.2722 62.539L37.1742 44.1788Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2226 39.0948L17.8615 35.2705L37.1742 44.1788L37.2226 39.0948Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9037 79.3945L68.9311 75.8158L75.1347 88.4942L65.3288 100.213L54.3784 94.1196L56.9037 79.3945Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2169 88.5784L100.298 91.0685L106.445 105.319L77.2449 122.952L85.2169 88.5784Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9643 135.533L31.4063 103.456L54.3784 94.1196L65.3288 100.213L59.9426 120.046L20.9643 135.533Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1347 88.4942L85.2169 88.5784L77.2449 122.952L59.9426 120.046L65.3288 100.213L75.1347 88.4942Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.231689 78.5757L24.3113 102.759L30.4469 106.386L31.4063 103.456L0.231689 78.5757Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3539 125.061L3.88347 129.939L24.3113 102.759L30.4469 106.386L24.3539 125.061Z",
    fill: "url(#paint28_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1238 131.842L3.88347 129.939L24.3539 125.061L22.1238 131.842Z",
    fill: "url(#paint29_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9426 120.046L77.2449 122.952L80.1431 136.02L68.9379 129.274L59.9426 120.046Z",
    fill: "url(#paint30_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9643 135.533L59.3925 140.417L68.9379 129.274L59.9426 120.046L20.9643 135.533Z",
    fill: "url(#paint31_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1431 136.02L74.0801 177.083L59.3925 140.417L68.9379 129.274L80.1431 136.02Z",
    fill: "url(#paint32_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6258 137.79L38.1726 161.072L65.8873 156.474L59.3925 140.417L38.6258 137.79Z",
    fill: "url(#paint33_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.445 105.319L106.663 113.953L97.054 125.525L80.1431 136.02L77.2449 122.952L106.445 105.319Z",
    fill: "url(#paint34_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.776 95.7646L142.609 111.273L120.099 116.288L106.663 113.953L106.445 105.319L145.776 95.7646Z",
    fill: "url(#paint35_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.321 70.7331L157.061 101.381L145.085 99.2614L145.776 95.7646L146.793 85.9079L184.321 70.7331Z",
    fill: "url(#paint36_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.609 111.273L174.566 136.795L157.061 101.381L145.085 99.2614L142.609 111.273Z",
    fill: "url(#paint37_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.099 116.288L142.609 111.273L174.566 136.795L137.814 143.745L118.222 129.002L120.099 116.288Z",
    fill: "url(#paint38_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.663 113.953L120.099 116.288L118.222 129.002L104.847 134.576L97.054 125.525L106.663 113.953Z",
    fill: "url(#paint39_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0801 177.083L80.1431 136.02L97.054 125.525L104.847 134.576L101.346 158.286L74.0801 177.083Z",
    fill: "url(#paint40_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.814 143.745L118.222 129.002L104.847 134.576L101.346 158.286L131.616 182.155L137.814 143.745Z",
    fill: "url(#paint41_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9501 188.686L80.1292 172.973L74.4617 176.876L78.9501 188.686Z",
    fill: "url(#paint42_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.616 182.155L101.444 163.567L98.512 160.238L101.346 158.286L131.616 182.155Z",
    fill: "url(#paint43_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9501 188.686L101.444 163.567L98.512 160.238L80.1292 172.973L78.9501 188.686Z",
    fill: "url(#paint44_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.84 149.746L166.481 153.508L156.24 140.233L137.814 143.745L136.84 149.746Z",
    fill: "url(#paint45_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.853 139.538L166.481 153.508L156.24 140.233L159.853 139.538Z",
    fill: "url(#paint46_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.229 113.703L170.328 108.431L162.012 95.7917L157.061 101.381L163.229 113.703Z",
    fill: "url(#paint47_linear)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.293 55.861L119.807 32.065L155.856 17.9886L150.186 56.3886L127.805 65.2853L116.293 55.861Z",
    fill: "url(#paint48_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.985 76.4277L146.793 85.9079L184.321 70.7332L171.758 65.4548L150.186 56.3886L127.805 65.2853L125.985 76.4277Z",
    fill: "url(#paint49_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M180.208 59.9437L150.63 53.3819L150.186 56.3886L171.758 65.4549L180.208 59.9437Z",
    fill: "#EAE9E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.736 66.6846L180.208 59.9436L171.758 65.4548L174.736 66.6846Z",
    fill: "url(#paint50_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.294 55.861L119.807 32.065L100.014 2.6333L93.9759 43.5245L107.035 60.9017L116.294 55.861Z",
    fill: "url(#paint51_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.856 17.9886L119.807 32.065L118.795 30.5988L121.292 29.7386L155.856 17.9886Z",
    fill: "url(#paint52_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.789 0.737L104.55 9.35988L118.795 30.5988L121.292 29.7386L106.789 0.737Z",
    fill: "#EAEAE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.245 5.94729L106.789 0.737012L104.55 9.35989L102.245 5.94729Z",
    fill: "url(#paint53_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0835 48.2044L93.9758 43.5245L100.013 2.6333L74.8672 35.6119L81.0835 48.2044Z",
    fill: "url(#paint54_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8702 49.2064L93.9759 43.5245L107.035 60.9017L112.44 73.6377L110.39 78.6018L87.8702 49.2064Z",
    fill: "#FDFCF4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M125.985 76.4277L127.805 65.2853L116.293 55.861L107.035 60.9017L112.44 73.6377L125.985 76.4277Z",
    fill: "#EFEEE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.39 78.6018L145.776 95.7646L146.793 85.9079L125.985 76.4277L112.44 73.6377L110.39 78.6018Z",
    fill: "#F0EFE7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8702 49.2064L93.9759 43.5245L81.0836 48.2044L70.2658 53.1027L87.8702 49.2064Z",
    fill: "url(#paint55_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8672 35.6119L37.1084 26.7889L70.2657 53.1027L81.0836 48.2043L74.8672 35.6119Z",
    fill: "url(#paint56_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4154 28.3555L59.6043 19.4893L55.5217 31.0877L74.8672 35.6119L80.4154 28.3555Z",
    fill: "url(#paint57_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.931 75.8159L70.2657 53.1027L37.1084 26.7889L37.2409 63.9389L56.9036 79.3945L68.931 75.8159Z",
    fill: "url(#paint58_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2169 88.5784L87.8702 49.2063L70.2658 53.1026L68.9311 75.8158L75.1347 88.4942L85.2169 88.5784Z",
    fill: "url(#paint59_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.39 78.6018L100.298 91.0685L85.2169 88.5784L87.8702 49.2064L110.39 78.6018Z",
    fill: "url(#paint60_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.777 95.7647L110.39 78.6019L100.298 91.0686L106.445 105.319L145.777 95.7647Z",
    fill: "url(#paint61_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.241 63.9389L0.231663 78.5757L31.4063 103.456L54.3783 94.1196L56.9036 79.3945L37.241 63.9389Z",
    fill: "url(#paint62_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2722 62.539L0.231719 78.5757L37.2411 63.9389L37.2722 62.539Z",
    fill: "url(#paint63_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1741 44.1788L17.8615 35.2705L30.1471 65.6126L37.2721 62.539L37.1741 44.1788Z",
    fill: "url(#paint64_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2226 39.0948L17.8615 35.2705L37.1741 44.1788L37.2226 39.0948Z",
    fill: "#EAE8E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9036 79.3945L68.931 75.8159L75.1347 88.4942L65.3287 100.213L54.3783 94.1196L56.9036 79.3945Z",
    fill: "url(#paint65_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2169 88.5784L100.298 91.0686L106.445 105.319L77.2448 122.952L85.2169 88.5784Z",
    fill: "url(#paint66_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9643 135.533L31.4063 103.456L54.3784 94.1196L65.3288 100.213L59.9426 120.046L20.9643 135.533Z",
    fill: "url(#paint67_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1347 88.4942L85.2168 88.5784L77.2448 122.952L59.9426 120.046L65.3287 100.213L75.1347 88.4942Z",
    fill: "#989898"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.231689 78.5757L24.3113 102.759L30.4469 106.386L31.4063 103.456L0.231689 78.5757Z",
    fill: "url(#paint68_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3539 125.061L3.88345 129.939L24.3112 102.759L30.4469 106.386L24.3539 125.061Z",
    fill: "url(#paint69_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1238 131.842L3.88344 129.939L24.3539 125.061L22.1238 131.842Z",
    fill: "url(#paint70_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9425 120.046L77.2448 122.952L80.1431 136.02L68.9378 129.274L59.9425 120.046Z",
    fill: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9644 135.533L59.3925 140.417L68.9379 129.274L59.9426 120.046L20.9644 135.533Z",
    fill: "url(#paint71_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1431 136.02L74.08 177.083L59.3925 140.417L68.9378 129.274L80.1431 136.02Z",
    fill: "url(#paint72_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6258 137.79L38.1726 161.072L65.8873 156.474L59.3925 140.417L38.6258 137.79Z",
    fill: "url(#paint73_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M106.445 105.319L106.663 113.953L97.0539 125.525L80.1431 136.02L77.2448 122.952L106.445 105.319Z",
    fill: "url(#paint74_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M145.777 95.7646L142.609 111.273L120.099 116.288L106.663 113.953L106.445 105.319L145.777 95.7646Z",
    fill: "url(#paint75_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M184.321 70.7332L157.061 101.381L145.085 99.2614L145.776 95.7646L146.793 85.9079L184.321 70.7332Z",
    fill: "url(#paint76_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M142.609 111.273L174.566 136.795L157.061 101.381L145.085 99.2614L142.609 111.273Z",
    fill: "#EBEAE2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M120.099 116.288L142.609 111.273L174.566 136.795L137.814 143.745L118.222 129.002L120.099 116.288Z",
    fill: "url(#paint77_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.663 113.953L120.099 116.288L118.222 129.002L104.847 134.576L97.0539 125.525L106.663 113.953Z",
    fill: "url(#paint78_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0801 177.083L80.1431 136.02L97.0539 125.525L104.847 134.576L101.346 158.286L74.0801 177.083Z",
    fill: "url(#paint79_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M137.814 143.745L118.222 129.002L104.847 134.576L101.346 158.286L131.616 182.155L137.814 143.745Z",
    fill: "url(#paint80_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9501 188.686L80.1292 172.973L74.4617 176.876L78.9501 188.686Z",
    fill: "url(#paint81_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M131.616 182.155L101.444 163.567L98.512 160.238L101.346 158.286L131.616 182.155Z",
    fill: "#313130"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9501 188.686L101.444 163.567L98.5119 160.238L80.1291 172.973L78.9501 188.686Z",
    fill: "url(#paint82_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M136.84 149.746L166.481 153.508L156.24 140.233L137.814 143.745L136.84 149.746Z",
    fill: "url(#paint83_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M159.853 139.538L166.481 153.508L156.24 140.233L159.853 139.538Z",
    fill: "#F8F7ED"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M163.229 113.703L170.328 108.431L162.012 95.7917L157.061 101.381L163.229 113.703Z",
    fill: "url(#paint84_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 188,
    fill: "#7933FE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 146.033,
    y1: 31.9352,
    x2: 123.576,
    y2: 56.8769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3539,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7066,
    stopColor: "#A3A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BDB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 127.208,
    y1: 67.9863,
    x2: 183.541,
    y2: 76.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB3AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2577,
    stopColor: "#BCBEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6283,
    stopColor: "#C8C9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 174.39,
    y1: 65.0375,
    x2: 180.015,
    y2: 60.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3539,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7066,
    stopColor: "#A3A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BDB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 101.659,
    y1: 26.1163,
    x2: 116.606,
    y2: 59.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#EDEDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9599,
    stopColor: "#DBDBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A8A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 122.865,
    y1: 30.0071,
    x2: 155.435,
    y2: 17.8342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90918D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3787,
    stopColor: "#8D8E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6377,
    stopColor: "#848582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8603,
    stopColor: "#757774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 102.824,
    y1: 8.47678,
    x2: 108.367,
    y2: 0.501037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0319113,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2301,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3478,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 82.0141,
    y1: 45.7551,
    x2: 98.4791,
    y2: 4.01109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6012,
    stopColor: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 71.1834,
    y1: 46.6907,
    x2: 93.0558,
    y2: 49.9202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1905,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 36.8245,
    y1: 27.6858,
    x2: 79.0791,
    y2: 47.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2046,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4895,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8203,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8696,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 56.1394,
    y1: 16.4341,
    x2: 72.1262,
    y2: 34.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3539,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7066,
    stopColor: "#A3A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BDB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 58.8588,
    y1: 70.1911,
    x2: 43.4021,
    y2: 34.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4189,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7055,
    stopColor: "#5A5B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9517,
    stopColor: "#686A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 92.0213,
    y1: 48.9854,
    x2: 70.0074,
    y2: 82.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9723,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 100.25,
    y1: 91.1314,
    x2: 87.6563,
    y2: 52.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0632411,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1065,
    stopColor: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#838380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4409,
    stopColor: "#92928D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6542,
    stopColor: "#9A9A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 100.366,
    y1: 90.794,
    x2: 145.527,
    y2: 97.4621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#787878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0970728,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4347,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7449,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 0.219296,
    y1: 78.6595,
    x2: 55.7654,
    y2: 86.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90918D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3787,
    stopColor: "#8D8E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6377,
    stopColor: "#848582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8603,
    stopColor: "#757774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 1.78759,
    y1: 68.0383,
    x2: 35.9335,
    y2: 73.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1905,
    stopColor: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 19.8492,
    y1: 44.0575,
    x2: 38.097,
    y2: 58.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3539,
    stopColor: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7066,
    stopColor: "#A3A5A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BDB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 55.5263,
    y1: 86.3032,
    x2: 75.0388,
    y2: 89.1843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    stopColor: "#7A7C79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4797,
    stopColor: "#838481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 82.7955,
    y1: 115.684,
    x2: 101.054,
    y2: 89.4711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1634,
    stopColor: "#E2E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#B8B8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9251,
    stopColor: "#747473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 35.5721,
    y1: 123.005,
    x2: 61.4988,
    y2: 94.1241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#A2A39E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6025,
    stopColor: "#999A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8127,
    stopColor: "#8A8C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#757775"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: -1.45503,
    y1: 89.9993,
    x2: 32.6909,
    y2: 95.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4382,
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: -0.626867,
    y1: 130.628,
    x2: 34.2173,
    y2: 107.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90918D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3787,
    stopColor: "#8D8E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6377,
    stopColor: "#848582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8603,
    stopColor: "#757774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: -1.32622,
    y1: 130.515,
    x2: 23.7715,
    y2: 128.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4382,
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 22.4602,
    y1: 125.125,
    x2: 68.5163,
    y2: 131.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0442709,
    stopColor: "#686A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#5A5B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5328,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 71.3363,
    y1: 167.883,
    x2: 69.6664,
    y2: 135.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4189,
    stopColor: "#888985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7055,
    stopColor: "#7F817D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9517,
    stopColor: "#707270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 42.8098,
    y1: 157.801,
    x2: 55.514,
    y2: 143.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4382,
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333333"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 77.8959,
    y1: 118.427,
    x2: 105.413,
    y2: 122.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3224,
    stopColor: "#A2A39E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#999A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7324,
    stopColor: "#8A8C88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9012,
    stopColor: "#757775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 115.406,
    y1: 113.367,
    x2: 148.219,
    y2: 95.1317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 145.317,
    y1: 98.5779,
    x2: 180.036,
    y2: 72.5356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0482782,
    stopColor: "#707270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2945,
    stopColor: "#7F817D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    stopColor: "#888985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8C88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 118.885,
    y1: 124.359,
    x2: 175.218,
    y2: 132.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4189,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7055,
    stopColor: "#5A5B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9517,
    stopColor: "#686A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6E6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 108.189,
    y1: 119.413,
    x2: 113.669,
    y2: 140.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72736F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F615F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 80.1368,
    y1: 164.223,
    x2: 110.474,
    y2: 115.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1634,
    stopColor: "#E2E2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#B8B8B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9251,
    stopColor: "#747473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 114.911,
    y1: 138.919,
    x2: 131.078,
    y2: 180.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2423,
    stopColor: "#848683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7108,
    stopColor: "#9C9D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A6A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 74.0366,
    y1: 180.031,
    x2: 80.0634,
    y2: 180.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0442709,
    stopColor: "#686A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#5A5B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5328,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 85.7618,
    y1: 174.903,
    x2: 100.045,
    y2: 161.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C6E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0442709,
    stopColor: "#686A68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2701,
    stopColor: "#5A5B5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5328,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 137.726,
    y1: 143.714,
    x2: 167.276,
    y2: 148.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0097245,
    stopColor: "#767876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3897,
    stopColor: "#90918D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7314,
    stopColor: "#9FA19C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A6A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 153.013,
    y1: 100.364,
    x2: 172.717,
    y2: 109.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1304,
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1797,
    stopColor: "#BDBDBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5105,
    stopColor: "#DBDBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7954,
    stopColor: "#EDEDE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel6);
export default __webpack_public_path__ + "static/media/level6.b47b920bb92c70a9303c32be8ef61423.svg";
export { ForwardRef as ReactComponent };